import { render, staticRenderFns } from "./AddExaminee.vue?vue&type=template&id=5433d30e&scoped=true"
import script from "./AddExaminee.vue?vue&type=script&lang=js"
export * from "./AddExaminee.vue?vue&type=script&lang=js"
import style0 from "./AddExaminee.vue?vue&type=style&index=0&id=5433d30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5433d30e",
  null
  
)

export default component.exports